<script lang="ts">
  import { _ } from 'svelte-i18n'
  import { params, pop } from 'svelte-spa-router'
  import { scrolledPublicationId } from '../pages/Newsline/store';

  const isHaveNextUrl: string | null = localStorage.getItem('next_url');

  const backHandler = () => {
    if (isHaveNextUrl && isHaveNextUrl.includes($params.publ_id)) {
      localStorage.removeItem('next_url');
      window.open('pht://navigate?to=back');
    } else {
      $scrolledPublicationId = $params.publ_id;
      pop()
    }
  }
</script>


<div class="main" on:click={backHandler}>
  <span class="main__button text-bold">
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.77243 0.743512C4.40931 1.02726 3.9141 1.4268 3.3884 1.88846C2.86538 2.34778 2.29588 2.88281 1.79188 3.4374C1.3118 3.96567 0.821801 4.58622 0.514842 5.22918C0.496937 5.26523 0.480424 5.30225 0.465388 5.34018C0.361986 5.59712 0.342727 5.84009 0.34409 6.00016C0.342727 6.16023 0.361986 6.4032 0.465388 6.66014C0.480424 6.69807 0.496937 6.73509 0.514842 6.77114C0.8218 7.4141 1.3118 8.03465 1.79188 8.56292C2.29588 9.11751 2.86538 9.65254 3.3884 10.1119C3.9141 10.5735 4.40931 10.9731 4.77243 11.2568C5.0281 11.4566 5.28384 11.6886 5.57274 11.8379C6.20231 12.1632 6.99259 11.9898 7.42216 11.3992C7.8909 10.7547 7.74241 9.82908 7.09973 9.36003C5.98092 8.53759 4.8877 7.62935 3.95206 6.59979C3.75149 6.37909 3.58581 6.17807 3.45429 6.00016C3.58581 5.82225 3.75149 5.62123 3.95206 5.40053C4.95984 4.29158 6.49781 3.09124 6.96331 2.74165C7.63731 2.23547 7.96268 1.34436 7.42216 0.601155C6.96141 -0.0323833 6.0863 -0.186334 5.43903 0.240701C5.21233 0.402186 4.99171 0.572154 4.77243 0.743512Z" fill="#576CED"/>
    </svg>
      
    <span class="main__span">{$_('Back')}</span>
  </span>
</div>

<style>
  .main {
    display: none;
  }
  @media (min-width: 320px) and (max-width: 1000px) {
    .main {
      padding: 0 24px;
      position: fixed;
      width: 100%;   
      display: flex;
      height: 40px;
      z-index:99999;
      top: 0;
      background: #EFF1FD;
    }

    .main__button {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #576CED; 
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }

    .main__span {
      padding-left: 12px;
    }
  }

  @media (max-width: 500px) {
    .main {
      width: 100%; 
      margin: 0 0 0 0;
    }
  }
</style>
